function isBadge(item) { return item.badgeColor && item.badgeText; }
function isTimer(item) { return item.specialDiscount && item.specialDiscount.endDate && new Date(item.specialDiscount.endDate) > new Date(); }
function isSalesDeal(item) { return isBadge(item) || isTimer(item); }
function takeDealListShown(dealData, dealType, marketerId, agencyMarketerContent, applyOneDealRule = false, liveshowProducts = []) {
  const tempArray = [];
  const dealList = [];
  dealType.forEach((item) => {
    const shouldShowMainDeals = agencyMarketerContent?.marketerSpecificContents?.showMainDeals ?? true;
    const dealCategoriesToShow = agencyMarketerContent?.marketerSpecificContents?.dealCategoriesToShow ?? [];

    const shouldInclude = marketerId === ''
      || shouldShowMainDeals
      || (Array.isArray(dealCategoriesToShow) && dealCategoriesToShow.includes(item.id));

    if (shouldInclude) {
      tempArray.push({
        name: item.name,
        id: item.id,
        list: [],
        sortOrder: item.sortOrder,
        agencyCode: item.agencyCode,
        applyOneDealRuleOnLP: item.applyOneDealRuleOnLP,
      });
    }
  });

  tempArray.forEach((elm) => {
    // Filter the deals matched category and isSalesDeal is a false
    const listFilteredByDealType = dealData.filter(
      (item) => (
        item.dealCategoryIds.indexOf(elm.id) > -1 && !isSalesDeal(item)
      ),
    );
    // Filter the deals matched category and deal that isSalesDeal is true
    const salesDeals = dealData.filter(
      (item) => (
        item.dealCategoryIds.indexOf(elm.id) > -1 && isSalesDeal(item)
      ),
    );

    if (listFilteredByDealType.length > 0) {
      elm.list.push(...listFilteredByDealType.map((item) => ([String(item.hotelId), [item]])));
    }

    if (salesDeals.length > 0) elm.list.push(...salesDeals.map((item) => ([String(item.hotelId), [item]])));
  });

  // sort and filter part
  tempArray.forEach((item) => {
    // implementation for ShowOneDealRule
    if (applyOneDealRule && item.applyOneDealRuleOnLP) {
      // add only one deal per hotel, get cheapest deal
      const hotelDealMap = new Map();
      item.list.forEach(([hotelId, deals]) => {
        const deal = deals[0];
        // Parse checkinDate and get day of week (0: Sunday, 6: Saturday)
        const checkinDate = new Date(deal.checkinDate);
        const dayOfWeek = checkinDate.getDay();
        // Classify as 'weekend' (Thursday, Friday), else 'midweek'
        let type = (dayOfWeek === 4 || dayOfWeek === 5) ? 'weekend' : 'midweek';
        if (!hotelDealMap.has(hotelId)) {
          hotelDealMap.set(hotelId, { midweek: [], weekend: [] });
        }
        hotelDealMap.get(hotelId)[type].push(deal);
      });

      // For each hotel, pick up to 1 cheapest midweek and 1 cheapest weekend deal
      item.list = [];
      hotelDealMap.forEach((types, hotelId) => {
        ['midweek', 'weekend'].forEach(type => {
          if (types[type].length > 0) {
            // Group deals by checkinDate and pick the cheapest for each date
            const dealsByDate = {};
            types[type].forEach(deal => {
              const dateKey = new Date(deal.checkinDate).toISOString().split('T')[0];
              if (!dealsByDate[dateKey] || Number(deal.totalAfterDiscount) < Number(dealsByDate[dateKey].totalAfterDiscount)) {
                dealsByDate[dateKey] = deal;
              }
            });
            // Add only one deal per hotel per type (pick the cheapest among all dates)
            const cheapestDeal = Object.values(dealsByDate).sort((a, b) => Number(a.totalAfterDiscount) - Number(b.totalAfterDiscount))[0];
            if (cheapestDeal) {
              item.list.push([hotelId, [cheapestDeal]]);
            }
          }
        });
      });
    }
    item.list.sort((a, b) => {
      if (isSalesDeal(a[1][0]) && !isSalesDeal(b[1][0])) {
        return -1;
      } else if (!isSalesDeal(a[1][0]) && isSalesDeal(b[1][0])) {
        return 1;
      }
      return 0;
    });
    item.list.sort((a, b) => Number(a[1][0].totalAfterDiscount) - Number(b[1][0].totalAfterDiscount));
    item.list.sort((a, b) => {
      if (a[1][0].priority > b[1][0].priority) {
        return -1;
      } else if (a[1][0].priority < b[1][0].priority) {
        return 1;
      }
      return 0;
    });
    item.list.sort((a, b) => {
      if (a[1][0].dealGenerationSessionGuid === null && b[1][0].dealGenerationSessionGuid !== null) {
        return -1;
      } else if (a[1][0].dealGenerationSessionGuid !== null && b[1][0].dealGenerationSessionGuid === null) {
        return 1;
      }
      return 0;
    });
    item.list.sort((a, b) => {
      const aIsAtl = a[1][0].extendedProperties?.sourceName === 'ATLANTIS' || a[1][0].extendedProperties?.sourceName === 'GROUP';
      const bIsAtl = b[1][0].extendedProperties?.sourceName === 'ATLANTIS' || b[1][0].extendedProperties?.sourceName === 'GROUP';
      if (aIsAtl && !bIsAtl) {
        return -1;
      } else if (!aIsAtl && bIsAtl) {
        return 1;
      }
      return 0;
    });
    if (item.list.length > 0) dealList.push(item);
  });
  dealList.sort((a, b) => ((a.sortOrder < b.sortOrder) ? -1 : 1));
  if (marketerId !== undefined && marketerId !== null && marketerId !== '') {
    const idx = dealList.findIndex((a) => a.agencyCode === marketerId);
    if (idx !== -1) {
      const agencyTab = dealList.splice(idx, 1);
      dealList.splice(0, 0, agencyTab[0]);
    }
  }

  // add liveshow products to dealList at position 1 (second tab)
  if (liveshowProducts && liveshowProducts.length > 0) {
    const liveshowTab = {
      name: 'Liveshow Products',
      translationKey: 'home.vacation-and-show',
      list: liveshowProducts.map((product, idx) => [`liveshowProducts_${idx}`, [{...product, isLiveshowProduct: true }]]),
      sortOrder: 1.5, // Place after first tab
    };
    dealList.splice(1, 0, liveshowTab);
  }

  return dealList;
}

export {
  isBadge,
  isTimer,
  isSalesDeal,
  takeDealListShown,
};
